/**
 * Created by Yair on 22/03/2017.
 */

import Vue from 'vue';

export default new Vue();
